import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const FlashCard = ({ card, isFlipped, onFlip }) => (
  <Box
    id="studyDeck__box_cardScene"
    className="cardScene"
    onClick={onFlip}
    role="button"
    tabIndex={0}
    aria-label="Flip card"
    onKeyDown={(e) => e.key === 'Enter' && onFlip()}
  >
    <motion.div
      className="flashCard"
      animate={{ rotateX: isFlipped ? 180 : 0 }}
      transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
      style={{ transformStyle: 'preserve-3d' }}
    >
      <Box id="studyDeck__box_cardFaceFront" className="cardFace front">
        <Typography id="studyDeck__text_cardFrontText" className="cardMainText">
          {card.name}
        </Typography>
      </Box>

      <Box id="studyDeck__box_cardFaceBack" className="cardFace back">
        <Typography id="studyDeck__text_cardBackText" className="cardMainText">
          {card.definition}
        </Typography>
      </Box>
    </motion.div>
  </Box>
);
